'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdNewReleases = function MdNewReleases(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 21.6v-10h-3.2v10h3.2z m0 6.8v-3.4h-3.2v3.4h3.2z m16.8-8.4l-4.1 4.6 0.5 6.2-6 1.3-3.1 5.3-5.7-2.4-5.7 2.4-3.1-5.2-6-1.4 0.5-6.2-4.1-4.6 4.1-4.7-0.5-6.1 6-1.3 3.1-5.3 5.7 2.4 5.7-2.4 3.1 5.3 6 1.3-0.5 6.2z' })
        )
    );
};

exports.default = MdNewReleases;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/new-releases.js
// module id = 3132
// module chunks = 0